import React, { createContext, useState, Dispatch, SetStateAction, ReactNode } from 'react';
import { AccountSearchParametersQuery, SortDirection, SortField } from 'eve-account-client';

export interface ManageCompaniesContextProps {
  children: ReactNode;
}

const defaultQuery: AccountSearchParametersQuery = {
  accountIds: undefined,
  city: undefined,
  companyName: undefined,
  stateCode: undefined,
  status: undefined,
  streetAddress: undefined,
  zipCode: undefined,
};

type Context = {
  query: AccountSearchParametersQuery;
  setQuery: Dispatch<SetStateAction<AccountSearchParametersQuery>>;
  sortField: SortField;
  setSortField: Dispatch<SetStateAction<SortField>>;
  sortDirection: SortDirection;
  setSortDirection: Dispatch<SetStateAction<SortDirection>>;
  pageSize: number;
  setPageSize: Dispatch<SetStateAction<number>>;
  pageIndex: number;
  setPageIndex: Dispatch<SetStateAction<number>>;
};

const initialContext: Context = {
  query: defaultQuery,
  setQuery: (): void => {
    throw new Error('setQuery function must be overridden');
  },
  sortField: SortField.COMPANYNAME,
  setSortField: (): void => {
    throw new Error('setSortField function must be overridden');
  },
  sortDirection: SortDirection.ASC,
  setSortDirection: (): void => {
    throw new Error('setSortDirection function must be overridden');
  },
  pageSize: 10,
  setPageSize: (): void => {
    throw new Error('setPageSize function must be overridden');
  },
  pageIndex: 0,
  setPageIndex: (): void => {
    throw new Error('setPageIndex function must be overridden');
  },
};

const ManageCompaniesContext = createContext(initialContext);

export const ManageCompaniesProvider = ({ children }: ManageCompaniesContextProps): JSX.Element => {
  const [query, setQuery] = useState(defaultQuery);
  const [sortField, setSortField] = useState(SortField.COMPANYNAME);
  const [sortDirection, setSortDirection] = useState(SortDirection.ASC);
  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(0);

  return (
    <ManageCompaniesContext.Provider
      value={{
        query,
        setQuery,
        sortField,
        setSortField,
        sortDirection,
        setSortDirection,
        pageSize,
        setPageSize,
        pageIndex,
        setPageIndex,
      }}
    >
      {children}
    </ManageCompaniesContext.Provider>
  );
};

export default ManageCompaniesContext;
